<template>
  <form>
    <div class="w-full">
      <paragraph class="pb-5 text-sm">配信ペースルールは、ポートフォリオに設定された予算に対して、事前に設定された利用ペースに基づいて自動的に入札額を調整します。</paragraph>
    </div>
    <vx-label-tooltip
      label="対象ポートフォリオ"
      text="入札ルールを適応するポートフォリオを選択します。ポートフォリオに属しないキャンペーンに入札ルールを適応することはできません。"
      position="bottom"
      min-width="250px"
      z-index="53001"
    />
    <select-field
      v-model="innerPortfolios"
      name="対象ポートフォリオ"
      label=""
      rules="required"
      :options="optionPortfolios"
      :max-result-shown="maxResultShown"
      :searchable="false"
      multiple
      full-width
      return-object
    />
    <vx-label-tooltip
      label="キャンペーン名の除外キーワード"
      text="入札ルールを適応しないキャンペーンを設定することができます。キャンペーンに特定のキーワードが含まれる場合は入札ルールの対象外となります。"
      position="bottom"
      min-width="250px"
      z-index="53001"
      class="mt-4"
    />
    <input-field
      v-model="innerNegativeKeyword"
      name="キャンペーン名の除外キーワード"
      label=""
      full-width
    />
    <select-field
      v-model="innerFrequency"
      name="ルール実行頻度"
      label="ルール実行頻度"
      class="mt-4"
      rules="required"
      :options="optionFrequencies"
      :max-result-shown="maxResultShown"
      :searchable="false"
      multiple
      full-width
    />
    <div class="vx-row items-end">
      <div class="vx-col w-3/5">
        <vx-label-tooltip
          label="ルックバック期間"
          text="前日から遡及して何日分のデータで入札ルールを計算するか指定します。"
          position="bottom"
          min-width="250px"
          z-index="53001"
        />
        <input-field
          v-model.number="innerLookback"
          name="ルックバック期間"
          label=""
          type="number"
          rules="required|integer|min_value:1|max_value:30"
          full-width
        />
      </div>
      <div class="vx-col w-2/5">
        <span>日前</span>
      </div>
    </div>
    <p
      class="mt-5 text-lg strong"
      style="font-weight: bold;"
    >
      入札強化
    </p>
    <div class="vx-row items-end">
      <div class="vx-col w-3/5">
        <input-field
          v-model.number="innerUpUsagePace"
          name="入札強化の利用ペース"
          label="利用ペース"
          type="number"
          rules="integer|min_value:50|max_value:120"
          full-width
        />
      </div>
      <div class="vx-col w-2/5">
        <span>％以下</span>
      </div>
    </div>
    <div class="vx-row items-end">
      <div class="vx-col w-3/5">
        <input-field
          v-model.number="innerUpBidChange"
          name="入札強化の入札変更"
          label="入札変更"
          type="number"
          rules="integer|min_value:1|max_value:30"
          full-width
        />
      </div>
      <div class="vx-col w-2/5">
        <span>％入札額を引き上げる</span>
      </div>
    </div>
    <div class="vx-row items-end">
      <div class="vx-col w-3/5">
        <vx-label-tooltip
          label="最大BID"
          text="入札ルールを計算した結果、最大BIDを超える場合は、最大BIDの価格で入札金額が設定されます。

元々の入札金額が最大BIDを超えている場合は入札金額を変更しません。"
          position="bottom"
          min-width="250px"
          z-index="53001"
        />
        <input-field
          v-model.number="innerUpMaxBid"
          name="入札強化の最大BID"
          label=""
          type="number"
          rules="integer|min_value:1|max_value:2000"
          full-width
        />
      </div>
      <div class="vx-col w-2/5">
        <span>円</span>
      </div>
    </div>
    <div class="vx-row items-end">
      <div class="vx-col w-3/5">
        <vx-label-tooltip
          label="変更対象外のキーワードの閾値"
          text="指定されたクリック数がないキーワードは条件に一致しても入札ルールが適応されます。"
          position="bottom"
          min-width="250px"
          z-index="53001"
        />
        <input-field
          v-model.number="innerUpClick"
          name="入札強化の変更対象外のキーワードの閾値"
          label=""
          type="number"
          rules="integer|min_value:1|max_value:30"
          full-width
        />
      </div>
      <div class="vx-col w-2/5">
        <span>クリック以上</span>
      </div>
    </div>
    <div class="vx-row items-end">
      <div class="vx-col w-3/5">
        <vx-label-tooltip
          label="変更対象外のキーワードのROAS基準"
          text="・各ポートフォリオの全体ROASに対する倍率
各ポートフォリオごとの全体ROASに対して倍率を設定してROAS基準を設定します。
※ポートフォリオの全体ROASが300%で倍率80%で設定した場合は、ROAS240%以下のキーワードが入札対象外になります。

・ROAS固定値
入札UPの対象外となるROASを固定値で指定します。"
          position="bottom"
          min-width="250px"
          z-index="53001"
        />
        <select-field
          v-model="innerUpRoasType"
          name="入札強化の変更対象のキーワードのROAS基準"
          label=""
          rules=""
          :options="optionRoasTypes"
          :searchable="false"
          full-width
        />
      </div>
      <div class="vx-col w-1/5">
        <input-field
          v-model.number="innerUpRoasValue"
          name="入札強化の倍率"
          label=""
          type="number"
          class="mt-4"
          :rules="`integer${(this.innerUpRoasType === 1) ? '|min_value:1|max_value:100' : '|min_value:1'}`"
          full-width
        />
      </div>
      <div class="vx-col w-1/5">
        <span>％以下</span>
      </div>
    </div>
    <p
      class="mt-5 text-lg strong"
      style="font-weight: bold;"
    >
      入札抑制
    </p>
    <div class="vx-row items-end">
      <div class="vx-col w-3/5">
        <input-field
          v-model.number="innerDownUsagePace"
          name="入札抑制の利用ペース"
          label="利用ペース"
          type="number"
          rules="required|integer|min_value:80|max_value:150"
          full-width
        />
      </div>
      <div class="vx-col w-2/5">
        <span>％以上</span>
      </div>
    </div>
    <div class="vx-row items-end">
      <div class="vx-col w-3/5">
        <vx-label-tooltip
          label="変更対象のキーワードの閾値"
          text="指定されたクリック数がないキーワードは条件に一致しても入札ルールが適応されません。"
          position="bottom"
          min-width="250px"
          z-index="53001"
        />
        <input-field
          v-model.number="innerDownClick"
          name="入札抑制の変更対象のキーワードの閾値"
          label=""
          type="number"
          rules="required|integer|min_value:5|max_value:30"
          full-width
        />
      </div>
      <div class="vx-col w-2/5">
        <span>クリック以上</span>
      </div>
    </div>
    <div class="vx-row items-end">
      <div class="vx-col w-3/5">
        <vx-label-tooltip
          label="変更対象のキーワードのROAS基準"
          text="・各ポートフォリオの全体ROASに対する倍率
各ポートフォリオごとの全体ROASに対して倍率を設定してROAS基準を設定します。
※ポートフォリオの全体ROASが300%で倍率80%で設定した場合は、ROAS240%以下のキーワードが入札DOWNの対象になります。

・ROAS固定値
入札UPの対象となるROASを固定値で指定します。"
          position="bottom"
          min-width="250px"
          z-index="53001"
        />
        <select-field
          v-model="innerDownRoasType"
          name="入札抑制の変更対象のキーワードのROAS基準"
          label=""
          rules="required"
          :options="optionRoasTypes"
          :searchable="false"
          full-width
        />
      </div>
      <div class="vx-col w-1/5">
        <input-field
          v-model.number="innerDownRoasValue"
          name="入札抑制の倍率"
          label=""
          type="number"
          class="mt-4"
          :rules="`required|integer${(this.innerDownRoasType === 1) ? '|min_value:1|max_value:150' : '|min_value:1'}`"
          full-width
        />
      </div>
      <div class="vx-col w-1/5">
        <span>％以下</span>
      </div>
    </div>
    <div class="vx-row items-end">
      <div class="vx-col w-3/5">
        <input-field
          v-model.number="innerDownBidChange"
          name="入札抑制の入札変更"
          label="入札変更"
          type="number"
          rules="required|integer|min_value:1|max_value:30"
          full-width
        />
      </div>
      <div class="vx-col w-2/5">
        <span>％入札額を引き下げる</span>
      </div>
    </div>
  </form>
</template>

<script>
import { mapState } from 'vuex'
import InputField from '@/components/fields/InputField'
import SelectField from '@/components/fields/SelectField'
import VxLabelTooltip from '@/components/vx-tooltip/VxLabelTooltip'
import Paragraph from '@/components/Paragraph'

export default {
  name: 'AdBidDeliveryForm',
  components: {
    InputField,
    SelectField,
    VxLabelTooltip,
    Paragraph
  },
  props: {
    id: {
      type: Number,
      default: null
    },
    portfolioIds: {
      type: Array,
      default: () => []
    },
    negativeKeyword: {
      type: String,
      default: null
    },
    frequencyIds: {
      type: Array,
      default: () => [1, 3, 5]
    },
    lookback: {
      type: Number,
      default: null
    },
    upRule: {
      type: Object,
      default () {
        return {
          click: null,
          roas: {
            type: 1,
            value: null
          },
          bid_change: 15,
          max_bid: null,
          usage_pace: 95
        }
      }
    },
    downRule: {
      type: Object,
      default () {
        return {
          click: null,
          roas: {
            type: 1,
            value: null
          },
          bid_change: 15,
          usage_pace: 102
        }
      }
    }
  },
  emits: [
    'update:portfolio-ids',
    'update:negative-keyword',
    'update:frequency-ids',
    'update:lookback',
    'update:up-rule',
    'update:down-rule'
  ],
  data () {
    return {
      maxResultShown: 100,
      resizeObserver: null
    }
  },
  computed: {
    ...mapState('adBid', ['portfolios']),
    innerPortfolios: {
      get () {
        return this.portfolioIds
      },
      set (val) {
        this.$emit('update:portfolio-ids', val)
      }
    },
    innerNegativeKeyword: {
      get () {
        return this.negativeKeyword
      },
      set (val) {
        this.$emit('update:negative-keyword', val)
      }
    },
    innerFrequency: {
      get () {
        return this.frequencyIds
      },
      set (val) {
        this.$emit('update:frequency-ids', val)
      }
    },
    innerLookback: {
      get () {
        return this.lookback
      },
      set (val) {
        this.$emit('update:lookback', ((val === '') ? null : val))
      }
    },
    innerUpUsagePace: {
      get () {
        return (this.upRule) ? this.upRule.usage_pace : null
      },
      set (val) {
        this.$emit('update:up-rule', {...this.upRule, usage_pace: ((val === '') ? null : val)})
      }
    },
    innerUpClick: {
      get () {
        return (this.upRule) ? this.upRule.click : null
      },
      set (val) {
        this.$emit('update:up-rule', {...this.upRule, click: ((val === '') ? null : val)})
      }
    },
    innerUpRoasType: {
      get () {
        return (this.upRule && this.upRule.roas) ? this.upRule.roas.type : null
      },
      set (val) {
        this.$emit('update:up-rule', {...this.upRule, roas: {type: val, value: this.upRule?.roas?.value || null}})
      }
    },
    innerUpRoasValue: {
      get () {
        return (this.upRule && this.upRule.roas) ? this.upRule.roas.value : null
      },
      set (val) {
        this.$emit('update:up-rule', {...this.upRule, roas: {type: this.upRule?.roas?.type || 1, value: ((val === '') ? null : val)}})
      }
    },
    innerUpMaxBid: {
      get () {
        return (this.upRule) ? this.upRule.max_bid : null
      },
      set (val) {
        this.$emit('update:up-rule', {...this.upRule, max_bid: ((val === '') ? null : val)})
      }
    },
    innerUpBidChange: {
      get () {
        return (this.upRule) ? this.upRule.bid_change : null
      },
      set (val) {
        this.$emit('update:up-rule', {...this.upRule, bid_change: ((val === '') ? null : val)})
      }
    },
    innerDownUsagePace: {
      get () {
        return (this.downRule) ? this.downRule.usage_pace : null
      },
      set (val) {
        this.$emit('update:down-rule', {...this.downRule, usage_pace: ((val === '') ? null : val)})
      }
    },
    innerDownClick: {
      get () {
        return (this.downRule) ? this.downRule.click : 0
      },
      set (val) {
        this.$emit('update:down-rule', {...this.downRule, click: ((val === '') ? null : val)})
      }
    },
    innerDownRoasType: {
      get () {
        return (this.downRule && this.downRule.roas) ? this.downRule.roas.type : 1
      },
      set (val) {
        this.$emit('update:down-rule', {...this.downRule, roas: {type: val, value: this.downRule.roas.value}})
      }
    },
    innerDownRoasValue: {
      get () {
        return (this.downRule && this.downRule.roas) ? this.downRule.roas.value : null
      },
      set (val) {
        this.$emit('update:down-rule', {...this.downRule, roas: {type: this.downRule.roas.type, value: ((val === '') ? null : val)}})
      }
    },
    innerDownBidChange: {
      get () {
        return (this.downRule) ? this.downRule.bid_change : null
      },
      set (val) {
        this.$emit('update:down-rule', {...this.downRule, bid_change: ((val === '') ? null : val)})
      }
    },
    optionPortfolios () {
      return Object.entries(this.portfolios)
        .map(([id, { name, amount, policy, startDate, endDate }]) => {
          if (policy == 'dateRange') {
            return ({text: name, value: id, $isDisabled: (!amount || !startDate || !endDate) })
          }
          return ({text: name, value: id, $isDisabled: !amount })
        })
    },
    optionFrequencies () {
      return [
        {text: '日曜日', value: 0},
        {text: '月曜日', value: 1},
        {text: '火曜日', value: 2},
        {text: '水曜日', value: 3},
        {text: '木曜日', value: 4},
        {text: '金曜日', value: 5},
        {text: '土曜日', value: 6}
      ]
    },
    optionRoasTypes () {
      return [
        {text: '各ポートフォリオの全体ROASに対する倍率', value: 1},
        {text: 'ROAS固定値', value: 2}
      ]
    }
  }
}
</script>
